/** Chuẩn hóa role từ API (tránh lệch hoa/thường). */
export function normTeamRole(r) {
  if (r == null || r === '') return '';
  return String(r).toLowerCase();
}

/** Bản ghi auth/me cho một đội: ưu tiên đúng project_id, không thì chỉ khớp id (đội tham gia nhiều dự án). */
function authEntryForTeam(authTeams, teamId, projectId) {
  const tid = String(teamId);
  const pid = projectId != null && projectId !== '' ? String(projectId) : '';
  const at = authTeams || [];
  if (pid) {
    const exact = at.find((x) => String(x.id) === tid && String(x.project_id) === pid);
    if (exact) return exact;
  }
  return at.find((x) => String(x.id) === tid);
}

/**
 * Chọn đội làm việc cho nhà thầu trên một dự án.
 * 1) Đội cá nhân (owner_user_id = user) — mỗi tài khoản đã duyệt có một đội / dự án.
 * 2) Đội mà user là lead/member theo auth.
 * 3) Tránh teams[0] là đội viewer khi user còn đội khác có quyền thao tác.
 */
export function pickContractorTeamId(teams, authTeams, projectId, authUserId) {
  if (!teams?.length || !projectId) return '';
  const pid = String(projectId);
  const uid = authUserId != null && authUserId !== '' ? String(authUserId) : '';

  if (uid) {
    const own = teams.find((t) => t.owner_user_id != null && String(t.owner_user_id) === uid);
    if (own) return String(own.id);
  }

  const at = authTeams || [];
  let notViewer = '';
  for (const t of teams) {
    const tid = String(t.id);
    const m = authEntryForTeam(at, tid, pid);
    const role = normTeamRole(m?.team_role);
    if (role === 'lead' || role === 'member') return tid;
    if (role && role !== 'viewer') notViewer = notViewer || tid;
  }
  for (const t of teams) {
    const tid = String(t.id);
    const m = authEntryForTeam(at, tid, pid);
    const role = normTeamRole(m?.team_role);
    if (role && role !== 'viewer') return tid;
  }
  if (notViewer) return notViewer;
  return String(teams[0].id);
}
